import { Dispatch, SetStateAction } from "react";

export const CAMPUS_CD = "PTK";

export interface Community {
  cmtCd: string;
  cmtNm: string;
  cpsCd: string;
  delYn?: string;
}

export interface Garret {
  garCd: string;
  garNm: string;
  cmtCd: string;
  cpsCd: string;
  delYn?: string;
}

export interface Leaf {
  leafCd: string;
  leafNm: string;
  garCd: string;
  cmtCd: string;
  cpsCd: string;
  delYn?: string;
}

export interface OrgUser {
  userId?: string;
  mbrId?: string;
  userName: string;
  telNo?: string;
  roleId?: string;
  cmtNm?: string;
  garNm?: string;
  leafNm?: string;
}

export type MobileTab = "cmt" | "gar" | "leaf";

export interface PendingDelete {
  type: "community" | "garret" | "leaf";
  cd: string;
  nm: string;
}

export interface UserListOrg {
  name: string;
  users: OrgUser[];
}

export interface OpenUserListParams {
  cpsCd: string;
  cmtCd?: string;
  garCd?: string;
  leafCd?: string;
  name: string;
}

export interface ModalControls {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export interface OrgTreeState {
  communities: Community[];
  garrets: Garret[];
  leafs: Leaf[];
  selectedCmtCd: string | null;
  setSelectedCmtCd: Dispatch<SetStateAction<string | null>>;
  selectedGarCd: string | null;
  setSelectedGarCd: Dispatch<SetStateAction<string | null>>;
  selectedLeafCd: string | null;
  setSelectedLeafCd: Dispatch<SetStateAction<string | null>>;
  loadCommunities: () => Promise<void>;
  loadGarrets: (cmtCd: string) => Promise<void>;
  loadLeafs: (cmtCd: string, garCd: string) => Promise<void>;
}

export interface OrgActionsState {
  showAddCmt: boolean;
  setShowAddCmt: Dispatch<SetStateAction<boolean>>;
  showAddGar: boolean;
  setShowAddGar: Dispatch<SetStateAction<boolean>>;
  showAddLeaf: boolean;
  setShowAddLeaf: Dispatch<SetStateAction<boolean>>;
  editCmtCd: string | null;
  setEditCmtCd: Dispatch<SetStateAction<string | null>>;
  editCmtNm: string;
  setEditCmtNm: Dispatch<SetStateAction<string>>;
  editGarCd: string | null;
  setEditGarCd: Dispatch<SetStateAction<string | null>>;
  editGarNm: string;
  setEditGarNm: Dispatch<SetStateAction<string>>;
  editLeafCd: string | null;
  setEditLeafCd: Dispatch<SetStateAction<string | null>>;
  editLeafNm: string;
  setEditLeafNm: Dispatch<SetStateAction<string>>;
  clearAllEdits: () => void;
  confirmModal: ModalControls;
  pendingDelete: PendingDelete | null;
  setPendingDelete: Dispatch<SetStateAction<PendingDelete | null>>;
  userListModal: ModalControls;
  userListOrg: UserListOrg | null;
  setUserListOrg: Dispatch<SetStateAction<UserListOrg | null>>;
  openUserList: (params: OpenUserListParams) => Promise<void>;
  handleMoveUsers: (
    userIds: string[],
    cmtCd: string,
    garCd: string,
    leafCd: string,
  ) => Promise<void>;
  handleAddCommunity: (values: Record<string, string>) => Promise<void>;
  handleSaveCommunity: () => Promise<void>;
  handleRequestDeleteCommunity: (c: Community) => void;
  handleAddGarret: (values: Record<string, string>) => Promise<void>;
  handleSaveGarret: () => Promise<void>;
  handleRequestDeleteGarret: (g: Garret) => void;
  handleAddLeaf: (values: Record<string, string>) => Promise<void>;
  handleSaveLeaf: () => Promise<void>;
  handleRequestDeleteLeaf: (l: Leaf) => void;
  handleConfirmDelete: () => Promise<void>;
}
